const { default: urls } = require("../urls");

const DELAY_IN_MILLISECONDS = 2000;
const MAX_ITER_COUNT = 15;

const currentUrl = window.location.hostname === 'localhost' ? urls['local'] : `${window.location.origin}/`;

async function checkLicenseExpiry() {
  try {
    if (localStorage.getItem('auth-token')
      && (Number(localStorage.getItem('refreshableUntil')) || Number.MAX_VALUE) <= (Math.floor(Date.now() / 1000) + 300)
      && !JSON.parse(localStorage.getItem('isRenewingLicense')))
    {
      localStorage.setItem('isRenewingLicense', true);
      window.location.hash = 'login';
      localStorage.setItem('isRenewingLicense', false);
      localStorage.removeItem('auth-token');
      window.location.reload();
    } else if (localStorage.getItem('auth-token')
      && (Number(localStorage.getItem('licenseExpiresIn')) || Number.MAX_VALUE) <= (Math.floor(Date.now() / 1000) + 300)
      && !JSON.parse(localStorage.getItem('isRenewingLicense')))
    {
      localStorage.setItem('isRenewingLicense', true);
      let renewalResult = await fetch(`${currentUrl}api/v4/tenDuke/renewUserLicense`, {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('auth-token'),
          'Access-Control-Allow-Origin': '*'
        }
      });
      if (renewalResult.status !== 200) throw new Error('Unable to renew license.');
      renewalResult = await renewalResult.json()
      localStorage.setItem('auth-token', renewalResult.token);
      localStorage.setItem('licenseExpiresIn', Math.floor(renewalResult.licenseExpiresIn));
      localStorage.setItem('refreshableUntil', Math.floor(renewalResult.refreshableUntil));
      localStorage.setItem('isRenewingLicense', false);
    } else if (JSON.parse(localStorage.getItem('isRenewingLicense'))) {
      let iterCount = 0;
      while (JSON.parse(localStorage.getItem('isRenewingLicense')) && iterCount < MAX_ITER_COUNT) {
        await ((delay) => new Promise((resolve) => setTimeout(resolve, delay)))(DELAY_IN_MILLISECONDS);
        iterCount++;
      }
    }
    return;
  } catch (error) {
    console.error(`Error: ${error.message}`);
    localStorage.setItem('isRenewingLicense', false);
    localStorage.removeItem('auth-token');
    window.location.hash = 'login';
    window.location.reload();
  } finally {
    localStorage.setItem('isRenewingLicense', false);
  }
}

// module.exports = {
//   checkLicenseExpiry
// };
export { checkLicenseExpiry };